(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("diacart", [], factory);
	else if(typeof exports === 'object')
		exports["diacart"] = factory();
	else
		root["diacart"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 